/*********************************************************************************************
 * Splide Products reco
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    const routineSections = document.querySelectorAll('[data-section-hero-id]');
    let scrollCounter = 0;
    
    routineSections.forEach(function (section) {
        const id = '.mm-hero-collection-splide';
        const splideElem = section.querySelector(id);
    
        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            mmSplideInit(splideElem, section);
        }
    });

    function mmSplideInit(splideElem, section) {
        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : false,
            pagination  : false,
            gap         : '16px',
            fixedWidth  : 'fit-content',
            perMove     : 1,
            omitEnd     : true,
            padding     : {
            },
            breakpoints : {
                768: {
                }
            }
        }).mount();

        // Mise à jour lors des mouvements ou drag du carrousel
        splideInstance.on('moved', updateProgressBar);
        splideInstance.on('dragged', updateProgressBar);

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    }
});
